<template>
  <section v-if="displayTable">
    <h3 class="text-left text-primary">Payments</h3>
    <div v-if="error" class="alert alert-danger alert-icon" role="alert">
      <div class="alert-content">
        <p>{{ error }}</p>
      </div>
    </div>
    <payment-processor v-if="processing"
      :reference="reference"
      :checkout="processing"
      @cancelled="onCancel"
      @completed="onComplete"/>
    <template v-else>
      <!-- Table Desktop -->
      <table class="table d-md-table d-none w-100">
        <thead>
          <tr class="bg-primary text-white">
            <th class="w-25">Date</th>
            <th class="w-25">Amount ({{ currencySymbol }})</th>
            <th class="w-25">Status</th>
            <th class="w-25">Action</th>
          </tr>
        </thead>
        <tbody>
          <row-desktop v-for="checkout in clientCheckouts"
            :key="checkout.id"
            :checkout="checkout"
            :date-format="momentJSDateFormat"
            @process="onProcess"/>
        </tbody>
      </table>
      <!-- Table Mobile -->
      <div class="table mb-5 d-md-none d-block">
        <!-- Header -->
        <div class="bg-primary text-white d-flex font-weight-bold small">
          <div class="col-4 py-2">Date</div>
          <div class="col-4 py-2">Amount ({{ currencySymbol }})</div>
          <div class="col-4 py-2">Status</div>
        </div>
        <!-- Rows -->
        <row-mobile v-for="checkout in clientCheckouts"
          :key="checkout.id"
          :checkout="checkout"
          :date-format="momentJSDateFormat"
          @process="onProcess"/>
      </div>
    </template>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { DateFormatMixin } from '@/mixins/Format/DateFormatMixin'
import { CountryCacheMixin } from '@/mixins/Site/CountryCacheMixin'
import { ClientCheckoutsCacheMixin } from '@/mixins/Payment/ClientCheckoutsCacheMixin'
import { WebApi } from '@/services/WebApi'
import PaymentProcessor from '../Payments/PaymentProcessor.vue'
import PaymentDesktopRow from './PaymentDesktopRow.vue'
import PaymentMobileRow from './PaymentMobileRow.vue'

export default {
  name: 'Payments',
  mixins: [DateFormatMixin, CountryCacheMixin, ClientCheckoutsCacheMixin],
  props: {
    scheduleId: {
      type: String,
      default: ''
    },
    sequence: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      processing: null
    }
  },
  computed: {
    displayTable () {
      return this.clientCheckouts.length > 0
    }
  },
  methods: {
    ...mapActions('ClientCheckouts', [
      'updateClientCheckout'
    ]),
    tryUpdateClientCheckout () {
      const self = this
      if (!self.processing) {
        return
      }
      self.updateClientCheckout({ reference: self.reference, checkout: self.processing })
        .then(response => { self.afterUpdateClientCheckout(response.data) })
        .catch(error => { self.error = ErrorHelper.getError(error) })
    },
    onProcess (checkout) {
      this.error = ''
      this.processing = checkout
    },
    onCancel () {
      this.tryUpdateClientCheckout()
      this.processing = null
    },
    onComplete (message) {
      this.error = message || ''
      this.tryUpdateClientCheckout()
      this.processing = null
    },
    afterUpdateClientCheckout (value) {
      // paid or paid late
      if ([1, 2].includes(value?.status.id)) {
        this.tryAddNotification({
          sequence: this.sequence,
          checkoutId: value.id
        })
      }
    },
    tryAddNotification (payload) {
      const self = this
      self.error = ''
      WebApi.post('ClientAppointmentSchedule/' + self.scheduleId + '/Notification', payload)
        .catch(error => { self.error = error })
    }
  },
  components: {
    'row-desktop': PaymentDesktopRow,
    'row-mobile': PaymentMobileRow,
    'payment-processor': PaymentProcessor
  }
}
</script>
